export const BUDGET_USER_ACTION_TYPES = {
    BUDGET_USER_GET_SUCCESS: "BUDGET_USER_GET_SUCCESS",
};